export default __webpack_public_path__ + "static/media/GMA-NETWORK.0cae9b9e.png";